module.exports = __webpack_public_path__ + "img/n.061664c2.jpg";